const Assets = {
  logo: require('@src/assets/logo.png'),
  login: {
    back: require('@src/assets/login/back.jpg'),
  }
};
export default Assets;